/**
 * WordPress dependencies
 */
import { store, getContext, getElement, withScope, useEffect } from '@wordpress/interactivity';
import { computePosition, arrow, shift, offset, size } from "@floating-ui/dom";

const getHeader = () => {
	return document.querySelector( 'header.wp-block-template-part' );
};

const { state, actions } = store( 'quanta/mega-menu', {
	state: {
		activeMegaMenu: null,
		closeTimeouts: {},
	},
	actions: {

		toggleOnClick() {
            const context = getContext();

            if ( context.isMenuOpen ) {
                actions.closeMenu('click');
            } else {
                actions.openMenu('click');
            }
		},

		handleMenuHover( event ) {
            if (window.innerWidth < 768) return;

            const context = getContext();

			if ( state.closeTimeouts.hasOwnProperty( context.id ) ) {
				clearTimeout( state.closeTimeouts[ context.id ] );
			}

			console.log( 'enter' );
			actions.openMenu( 'click' );
			// actions.update();
		},

		handleMenuHoverExit( event ) {
            if (window.innerWidth < 768) return;

            const context = getContext();
			const { ref } = getElement();

			const menuContainer = context.megaMenu?.querySelector(
				'.wp-block-quanta-mega-menu__menu-container'
			);


			console.log( 'closing', context );

			state.closeTimeouts[ context.id ] = setTimeout(
				withScope( () => {
					console.log( 'inside' );
					actions.closeMenu();
				} ),
				100
			);

		},

		openMenu( menuOpenedOn = 'click' ) {
			const context = getContext();

			context.isMenuOpen = true;
		},

		closeMenu( menuClosedOn = 'click' ) {
			const context = getContext();

			console.log( context );

			context.isMenuOpen = false;
		},
	},
	callbacks: {
		logInView() {
			const context = getContext();

			if ( ! context.element ) {
				return;
			}

			const menuContainer = context.element;
            menuContainer.classList.toggle( 'open', context.isMenuOpen );

			if ( context.isMenuOpen ) {
				// menuContainer.removeAttribute( 'hidden' );

                if ( getHeader() ) {
                    getHeader().classList.add( 'mega-menu--open' );
                }
			} else {
				// menuContainer.setAttribute( 'hidden', '' );

                if ( getHeader() ) {
                    getHeader().classList.remove( 'mega-menu--open' );
                }
			}

			const menuItem = context.element.closest( '.wp-block-quanta-mega-menu' );

			const arrowEl = context.element.querySelector( '.wp-block-quanta-mega-menu__arrow' );

            if ( arrowEl ) {
                const arrowLen = arrowEl.offsetWidth;

                // Get half the arrow box's hypotenuse length
                const floatingOffset = Math.sqrt( 2 * arrowLen ** 2 ) / 2;
            }

            const header = document.querySelector( 'header.wp-block-template-part' );

			computePosition( header, menuContainer, {
				placement: "bottom-left",
				middleware: [
					shift(),
					// offset( floatingOffset ),
					// offset( 10 ),
					// arrow( { element: arrowEl } ),
					size( {
						apply( { availableWidth, availableHeight, elements } ) {
							console.log( { availableWidth } );

							// Change styles, e.g.
							Object.assign( elements.floating.style, {
								maxWidth: `${Math.max( 0, availableWidth )}px`,
								maxHeight: `${Math.max( 0, availableHeight )}px`,
							} );
						},
					} ),
				],
			} ).then( ( { x, y, placement, middlewareData } ) => {
				Object.assign( menuContainer.style, {
					left: `${x}px`,
					top: `${y}px`
				} );

				if ( middlewareData.arrow ) {
                    // Accessing the data
                    const { x: arrowX, y: arrowY } = middlewareData.arrow;

                    const side = placement.split( "-" )[ 0 ];

                    const staticSide = {
                        top: "bottom",
                        right: "left",
                        bottom: "top",
                        left: "right"
                    }[ side ];

                    Object.assign( arrowEl.style, {
                        left: arrowX != null ? `${arrowX}px` : "",
                        top: arrowY != null ? `${arrowY}px` : "",
                        right: "",
                        bottom: "",
                        [ staticSide ]: `${-arrowLen / 2}px`,
                        transform: "rotate(45deg)",
                    } );
                }
			} );
		},

		init() {
			const context = getContext();
			const { ref } = getElement();

			context.element = ref;
		}
	},
} );
